package pl.mothdigital.neuronowi.pages.specialists

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.layout.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.model.SpecialistData
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.components.*
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.cta.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.css.AlignItems

private val priceItems = listOf(
    PriceItem(
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_1_NAME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_1_TIME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_1_AMOUNT
    ),
    PriceItem(
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_2_NAME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_2_TIME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_2_AMOUNT
    ),
    PriceItem(
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_3_NAME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_3_TIME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_3_AMOUNT
    ),
    PriceItem(
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_4_NAME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_4_TIME,
        StringResources.PATRYCJA_OCHRYNIUK_PRICE_4_AMOUNT
    )
)

@Page
@Composable
fun PatrycjaOchryniukPage() {
    SpecialistPageLayout(
        title = "Patrycja Ochryniuk",
        headerSection = { HeaderSection() },
        profileSection = { ProfileSection() },
        specializationsSection = { SpecializationsSection() },
        servicesSection = { ServicesSection() },
        howItWorksSection = { HowItWorksSection() },
        //priceSection = { PriceSection() },
        ctaSection = { context ->
            CTASection(
                ctx = context,
                customAction = { js("window.scrollTo({ top: 0, behavior: 'smooth' })") },
            )
        }
    )
}

@Composable
private fun HeaderSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50)
            .toAttrs()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().margin { auto },
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH1 { Text(value = StringResources.PATRYCJA_OCHRYNIUK.fixPolishOrphans()) }
            AppP(color = SiteTheme.green._800, modifier = Modifier.fontSize(1.25.cssRem)) {
                Text(value = StringResources.PATRYCJA_OCHRYNIUK_ACADEMIC_TITLES.fixPolishOrphans())
            }
            AppP(
                color = SiteTheme.green._800,
                modifier = Modifier.fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
            ) {
                Text(StringResources.PATRYCJA_OCHRYNIUK_PHONE_NUMBER)
            }
            AppP(
                color = SiteTheme.green._800,
                modifier = Modifier.fontSize(1.25.cssRem)
            ) {
                Text(StringResources.PATRYCJA_OCHRYNIUK_EMAIL)
            }
        }
    }
}

@Composable
private fun ProfileSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        // Large screens: side-by-side image and text
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .flexWrap(FlexWrap.Wrap)
                .displayIfAtLeast(Breakpoint.LG)
                .gap(3.cssRem),
        ) {
            Image(
                src = ImageResources.avatarPatrycjaOchryniuk.src,
                description = ImageResources.avatarPatrycjaOchryniuk.description,
                modifier = Modifier
                    .width(400.px)
                    .borderRadius(1.cssRem)
                    .boxShadow(blurRadius = 8.px, color = SiteTheme.black._100)
            )
            Column(
                modifier = Modifier
                    .flex(1)
                    .gap(1.5.cssRem)
                    .padding(1.cssRem),
            ) {
                AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TITLE) }
                AppH3(color = SiteTheme.green._800) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_1.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_2.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_3.fixPolishOrphans()) }
                AppH3(color = SiteTheme.green._800) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_4.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_5.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_6.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_7.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_8.fixPolishOrphans()) }
                AppP(color = SiteTheme.green._800, modifier = Modifier.fontWeight(FontWeight.Bold).textAlign(TextAlign.Justify)) {
                    Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_INVITE.fixPolishOrphans())
                }
            }
        }
        // Medium and smaller: image above text
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .alignItems(AlignItems.Center)
                .displayUntil(Breakpoint.LG)
                .gap(1.5.cssRem)
                .padding(1.cssRem),
        ) {
            AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TITLE) }
            AppH3(color = SiteTheme.green._800) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_1.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_2.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_3.fixPolishOrphans()) }
            AppH3(color = SiteTheme.green._800) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_4.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_5.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_6.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_7.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_TEXT_8.fixPolishOrphans()) }
            AppP(color = SiteTheme.green._800, modifier = Modifier.fontWeight(FontWeight.Bold).textAlign(TextAlign.Justify)) {
                Text(value = StringResources.PATRYCJA_OCHRYNIUK_O_MNIE_INVITE.fixPolishOrphans())
            }
            Image(
                src = ImageResources.avatarPatrycjaOchryniuk.src,
                alt = ImageResources.avatarPatrycjaOchryniuk.description,
                modifier = Modifier
                    .widthIn(min = 300.px, max = 500.px)
                    .fillMaxWidth()
                    .borderRadius(1.cssRem)
                    .boxShadow(blurRadius = 8.px, color = SiteTheme.black._100)
            )
        }
    }
}

@Composable
private fun SpecializationsSection() {
    val specializations = listOf(
        SpecialistData(
            icon = { FaBrain() },
            title = StringResources.PATRYCJA_OCHRYNIUK_SPEC_BIOFEEDBACK_TITLE,
            description = StringResources.PATRYCJA_OCHRYNIUK_SPEC_BIOFEEDBACK_DESC
        ),
        SpecialistData(
            icon = { FaGraduationCap() },
            title = StringResources.PATRYCJA_OCHRYNIUK_SPEC_PEDAGOGIKA_TITLE,
            description = StringResources.PATRYCJA_OCHRYNIUK_SPEC_PEDAGOGIKA_DESC
        ),
        SpecialistData(
            icon = { FaChild() },
            title = StringResources.PATRYCJA_OCHRYNIUK_SPEC_ADHD_TITLE,
            description = StringResources.PATRYCJA_OCHRYNIUK_SPEC_ADHD_DESC
        ),
        SpecialistData(
            icon = { FaHeart() },
            title = StringResources.PATRYCJA_OCHRYNIUK_SPEC_EMOCJE_TITLE,
            description = StringResources.PATRYCJA_OCHRYNIUK_SPEC_EMOCJE_DESC
        )
    )

    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_SPECIALIZATIONS_TITLE) }

            SimpleGrid(
                modifier = Modifier.fillMaxWidth().gap(1.5.cssRem),
                numColumns = numColumns(base = 1, sm = 1, md = 2, lg = 2, xl = 2)
            ) {
                specializations.forEach { info ->
                    SpecialistInfoCard(
                        icon = info.icon,
                        title = info.title,
                        description = info.description
                    )
                }
            }
        }
    }
}

@Composable
private fun ServicesSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICES_TITLE.fixPolishOrphans()) }

            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) {
                Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICES_INTRO.fixPolishOrphans())
            }

            SimpleGrid(
                modifier = Modifier.fillMaxWidth().gap(1.cssRem),
                numColumns = numColumns(base = 1, sm = 1, md = 2, lg = 2, xl = 2)
            ) {
                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    AppH3 { Text("Dla dzieci i młodzieży".fixPolishOrphans()) }
                    Ul {
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_1.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_2.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_3.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_4.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_5.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_6.fixPolishOrphans()) }
                    }
                }

                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    AppH3 { Text("Dla dorosłych".fixPolishOrphans()) }
                    Ul {
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_7.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_8.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_9.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_10.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_11.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_12.fixPolishOrphans()) }
                        Li { Text(StringResources.PATRYCJA_OCHRYNIUK_SERVICE_13.fixPolishOrphans()) }
                    }
                }
            }
        }
    }
}

@Composable
private fun HowItWorksSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_HOW_IT_WORKS_TITLE.fixPolishOrphans()) }
            
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) {
                Text(StringResources.PATRYCJA_OCHRYNIUK_HOW_IT_WORKS_DESC.fixPolishOrphans())
            }
        }
    }
}

@Composable
private fun PriceSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.PATRYCJA_OCHRYNIUK_PRICE_TITLE.fixPolishOrphans()) }

            SpecialistPriceTable(priceItems = priceItems)

            AppP(modifier = Modifier.fontSize(0.9.cssRem), color = SiteTheme.black._700) {
                Text(StringResources.PATRYCJA_OCHRYNIUK_PRICE_NOTE.fixPolishOrphans())
            }
        }
    }
}
